<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-24 10:05:36
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-07-24 10:03:39
-->
<script setup lang='ts'>
import { APP_ROUTER, imageTransform } from '@qctsw/common'
import { contentRemoveTags, timeFormat, timeFrom } from '@qctsw/utils'
import type { NewsColumnPageResponse } from '@/server/types'

const props = withDefaults(defineProps<{
  item?: NewsColumnPageResponse
  showAuthor?: boolean
}>(), {
  showAuthor: true,
})

const tips = computed(() => {
  if (!props.item)
    return {}
  const tips: Record<string, string | number> = {
    date: (props.item.createTime),
    lookCount: props.item.lookCount ?? 0,
    commentCount: props.item.commentCount ?? 0,
    favorCount: props.item.goodCount || 0,
  }

  if (props.showAuthor)
    tips.author = props.item.authorName

  return tips
})
</script>

<template>
  <div v-if="item" class="flex">
    <NuxtLink
      v-if="item.coverImgUrl"
      :to="APP_ROUTER.newsDetail(item.id)"
      class="inline-block relative w-52 aspect-16/9 max-h-29.25 object-cover rounded overflow-hidden flex-shrink-0 mr-sm"
    >
      <img
        loading="lazy" :alt="item.title" class="w-full h-full"
        :src="imageTransform(item.coverImgUrl, { width: 208, height: 117 })"
      >
      <i v-if="item.articleFormatCode === 2" class="play-icon text-white text-8" />
    </NuxtLink>
    <span class="flex-grow min-w-0 inline-flex flex-col justify-between">
      <NuxtLink :to="APP_ROUTER.newsDetail(item.id)">
        <span class="line-clamp-1 hover:text-orange-6">
          <span class="font-bold">{{ item.title }}</span>
        </span>
        <slot name="content">
          <span class="line-clamp-3 mt-1 text-3.5 text-gray-5">
            {{ item.articleFormatCode === 0 ? contentRemoveTags(item.articleContent || item.content).replace(/\s+/g, '') : '' }}
          </span>
        </slot>
      </NuxtLink>
      <UtilContentTips :author-id="item.authorId" :tips-data="tips" />
    </span>
  </div>
</template>

<style lang='scss' scoped>

</style>
